var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.groupByTerm && !_vm.showSpinnerLayer
    ? _c(
        "section",
        { staticClass: "panel-view-container" },
        [
          _c("LfHeaderTitleComponent", {
            staticClass: "header-title",
            attrs: { title: _vm.headerText },
          }),
          _c("LexonKanbanSidebar", {
            attrs: {
              groupByTermProp: _vm.groupByTerm,
              sortByOptionProp: _vm.sortBy,
              checkboxes: _vm.kanbanColumns,
              responsibles: _vm.responsibles,
              filtersInfo: _vm.filtersInfo,
            },
            on: {
              "emit-search-term": _vm.emitSearchTermToKanban,
              "emit-group-by-term": _vm.emitGroupByTermToKanban,
              "emit-toggle-column": _vm.emitToggleColumn,
              "emit-sort-by-option": _vm.emitChangeSortOption,
              "emit-clear-filters": _vm.emitClearFilters,
              "emit-filters-info": _vm.emitFiltersInfo,
            },
          }),
          _c(
            "div",
            { staticClass: "kanban-and-configuration-module-container" },
            [
              _c("LexonKanbanComponent", {
                key: `kanba-key-${_vm.kanbanKey}`,
                attrs: {
                  kanbanColumns: _vm.kanbanColumns,
                  actions: _vm.actions,
                  sortByOptionProp: _vm.sortBy,
                  searchTerm: _vm.searchTerm,
                  groupByTerm: _vm.groupByTerm,
                  toggleColumnInfo: _vm.toggleColumnInfo,
                  swimlaneGroupByKeyField: _vm.groupByTerm,
                  responsibles: _vm.responsibles,
                  filtersInfo: _vm.filtersInfo,
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }